import React, { useEffect, useState } from 'react';
import { TrendingUp } from 'lucide-react';
interface IncomeProps {
  totalAssetCashflow?: number;
  onIncomeChange?: (totalIncome: number) => void;
}
export function Income({
  totalAssetCashflow = 0,
  onIncomeChange
}: IncomeProps) {
  const [salary, setSalary] = useState(2500);
  const totalMonthlyIncome = salary + totalAssetCashflow;
  // Call the callback whenever income changes
  useEffect(() => {
    if (onIncomeChange) {
      onIncomeChange(totalMonthlyIncome);
    }
  }, [totalMonthlyIncome, onIncomeChange]);
  const handleSalaryChange = (valueStr: string) => {
    // Convert input to number, defaulting to 0 if invalid
    const numValue = valueStr === '' ? 0 : Number(valueStr) || 0;
    setSalary(numValue);
  };
  return <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 h-full" data-id="element-133">
      <div className="flex items-center justify-between mb-4" data-id="element-134">
        <div className="flex items-center" data-id="element-135">
          <TrendingUp size={20} className="text-green-500 mr-2" data-id="element-136" />
          <h2 className="text-xl font-semibold" data-id="element-137">Income</h2>
        </div>
        <p className="text-lg font-bold text-green-600" data-id="element-138">
          ${totalMonthlyIncome.toLocaleString()}/mo
        </p>
      </div>
      <div className="space-y-3" data-id="element-139">
        <div className="flex justify-between items-center p-3 bg-gray-50 rounded-md" data-id="element-140">
          <div data-id="element-141">
            <p className="text-gray-700 font-medium" data-id="element-142">Salary</p>
            <p className="text-xs text-gray-500" data-id="element-143">Monthly</p>
          </div>
          <div className="flex items-center" data-id="element-144">
            <span className="mr-1" data-id="element-145">$</span>
            <input type="number" value={salary === 0 ? '' : salary} onChange={e => handleSalaryChange(e.target.value)} placeholder="0" className="font-medium bg-transparent text-right border-b border-transparent focus:border-green-500 focus:outline-none w-24" data-id="element-146" />
          </div>
        </div>
        <div className="flex justify-between items-center p-3 bg-gray-50 rounded-md" data-id="element-147">
          <div data-id="element-148">
            <p className="text-gray-700 font-medium" data-id="element-149">Passive Income</p>
            <p className="text-xs text-gray-500" data-id="element-150">Monthly from Assets</p>
          </div>
          <p className="font-medium text-green-600" data-id="element-151">
            ${totalAssetCashflow.toLocaleString()}
          </p>
        </div>
      </div>
    </div>;
}